<template>
  <div class="oct-app-bar">
    <v-app-bar elevation="2" app>
      <v-toolbar-title>
        <v-breadcrumbs large divider=">>" :items="breadcrumbItems"></v-breadcrumbs>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <oct-message-menu></oct-message-menu>

      <v-menu
          open-on-hover
          close-on-content-click
          offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
              color="primary"
              v-on="on"
          >
            {{LOGGEDINUSER.firstName}} {{LOGGEDINUSER.lastName}}
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(userMenuItem, index) in userMenuItems" :key="index"
              :to="userMenuItem.to">
            <v-list-item-title>{{userMenuItem.label}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LOGGEDINUSER } from "@/common/store/modules/auth";
import OctMessageMenu from "@/components/app/OctMessageMenu";
import { FETCH_DEPOT, DepotFetchParameter, DEPOT_STORE, DEPOT } from "@/common/store/modules/DepotStore";

export default {
  name: 'OctAppBar',
  components: {
    OctMessageMenu
  },
  data: () => ({
    userMenuItems: [
      {
        label: 'Settings',
        to: '/settings'
      },
      {
        label: 'Log out',
        to: '/logout'
      }
    ]
  }),
  computed: {
    ...mapGetters([LOGGEDINUSER]),
    ...mapGetters(DEPOT_STORE, [DEPOT]),
    breadcrumbItems () {
      // TODO: refactor this; provide this information in the stores of each page
      switch (this.$route.name) {
      case 'depots':
        return [
          {
            text: 'One Click Trading',
            to: '/'
          },
          {
            text: 'Depots',
            to: this.$route.fullPath
          },
        ];
      case 'depot':
        return [
          {
            text: 'One Click Trading',
            to: '/'
          },
          {
            text: 'Depots',
            to: '/depots'
          },
          {
            text: this.DEPOT.email,
            to: this.$route.fullPath
          },
        ];
      case 'settings':
        return [
          {
            text: 'One Click Trading',
            to: '/'
          },
          {
            text: 'Settings',
            to: this.$route.fullPath
          },
        ];
      default:
        return [
          {
            text: 'One Click Trading',
            to: '/'
          },
        ];
      }
    }
  },
  mounted () {
    if (this.$route.params.userId) {
      this.$store.dispatch(FETCH_DEPOT, { id: this.$route.params.userId });
    }
  }
};
</script>

<style>
  .v-application a.v-breadcrumbs__item {
    color: #455c6c;
  }

  .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled.v-breadcrumbs__item {
    color: #5aa680;
  }
</style>
